import type { ETemplateType, TVisibility } from 'types/template/template.types';
import { zTemplateTypeEnum } from 'types/template/template.types';
import { z } from 'zod';

export type TSourceScope = 'this' | 'other' | 'global';
export type SourceScopeItem = { label: string; value: TSourceScope };

const createSchema = z.object({
  mode: z.literal('create'),
  name: z.string().min(4, 'Please enter a valid name.'),
  type: zTemplateTypeEnum,
  accessGroupIds: z.array(z.string()).optional(),
  client_id: z.string(),
});

const copySchemaBase = z.object({
  mode: z.literal('copy'),
  name: z.string().min(4, 'Please enter a valid name.'),
  type: zTemplateTypeEnum,
  baseTemplateId: z.string().min(1, 'Base template is required.'),
  accessGroupIds: z.array(z.string()).optional(),
  targetClientId: z.string().optional(),
  sourceScope: z.enum(['this', 'other', 'global']),
  languageList: z.array(z.string()).optional(),
  allowedLanguages: z.array(z.object({ code: z.string() })).optional(),
  roleName: z.string().optional(),
  companyName: z.string().optional(),
});

export const zCreateTemplate = z.discriminatedUnion('mode', [createSchema, copySchemaBase]);

export type TCreateTemplate = z.infer<typeof zCreateTemplate>;
export type TCreateTemplateMode = 'create' | 'copy';

export type TCreateTemplateForm = {
  mode: TCreateTemplateMode;
  name: string;
  type: ETemplateType;
  visibility: TVisibility;
  useSourceClientForDestination: boolean;
  accessGroupIds?: string[];
  baseTemplateId?: string;
  sourceScope?: TSourceScope;
  sourceClientId?: string;
  destinationClientId?: string;
  startingLanguage?: string;
  allowedLanguages?: { code: string }[];
  supportedLanguages?: string[];
  roleName?: string;
  companyName?: string;
};
export type TCreateTemplatePayload = {
  name: string;
  type: ETemplateType;
  client_id?: string;
  baseTemplateId?: string;
  accessGroupIds?: string[];
  targetClientId?: string;
  languageList?: string[];
  allowedLanguages?: { code: string }[];
  roleName?: string;
  companyName?: string;
};
